import React, { useState } from 'react';

// Lightweight CSS hover-card — shows instantly on hover, unlike the native
// `title=` attribute's OS-controlled delay, and can be styled to match the
// rest of the bespoke design system (see theme.js).
const Tooltip = ({ text, children, placement = 'top' }) => {
  const [visible, setVisible] = useState(false);

  if (!text) return children;

  const isTop = placement === 'top';

  return (
    <span
      style={{ position: 'relative', display: 'inline-block' }}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && (
        <span
          role="tooltip"
          style={{
            position: 'absolute',
            [isTop ? 'bottom' : 'top']: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            marginBottom: isTop ? '6px' : 0,
            marginTop: isTop ? 0 : '6px',
            backgroundColor: '#0F172A',
            color: '#FFFFFF',
            padding: '6px 10px',
            borderRadius: '4px',
            fontSize: '0.75rem',
            fontFamily: '"Inter", sans-serif',
            fontWeight: 'normal',
            whiteSpace: 'normal',
            maxWidth: '260px',
            width: 'max-content',
            zIndex: 50,
            boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
            pointerEvents: 'none',
            lineHeight: 1.4,
          }}
        >
          {text}
        </span>
      )}
    </span>
  );
};

export default Tooltip;
